import feather from 'feather-icons';

import './singles/experiencia';
import './singles/municipio';
import './singles/ruta';

import './pages/blog';
import './pages/experiencias';
import './pages/municipios';

import './components/map';
import './components/customSelect';
import './components/hubspotForm';

jQuery(document).ready(function ($) {
	jQuery('.main-navigation').slicknav({
		label: "<i class='fas fa-bars'></i>",
		appendTo: '.nav_responsive',
		easingOpen: 'swing',
		openedSymbol: ''
	});
	const btn_nav_open = document.querySelector('.slicknav_btn');
	const btn_nav_close = document.querySelector('.slicknav_nav .close_nav');
	if (btn_nav_close) {
		btn_nav_close.addEventListener('click', function () {
			btn_nav_open.click();
		});
	}

	let videoDesktop = document.querySelector('.home__video__desktop video');
	let videoMobile = document.querySelector('.home__video__mobile video');

	if (videoDesktop) {
		videoDesktop.play();
	}

	if (videoMobile) {
		setTimeout(() => {
			videoMobile.play();
		}, 2000);
	}

	feather.replace();
});
